import { Link } from "react-router-dom";

const gradientStyle = {
  background: "linear-gradient(135deg, #4F7CFF 0%, #7B8CFF 100%)",
};
const gradientHover = {
  background: "linear-gradient(135deg, #3D6AE8 0%, #6B7CE8 100%)",
};

export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ backgroundColor: "#F8FAFC" }}
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://public.readdy.ai/ai/img_res/e3c2f3130d37e33363bd9eb6755bcc15.jpg)",
          backgroundPosition: "center right",
        }}
      />
      {/* Directional gradient overlay — heavy left (text area), fades right (image shows) */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, rgba(248,250,252,0.97) 0%, rgba(248,250,252,0.93) 30%, rgba(248,250,252,0.65) 55%, rgba(248,250,252,0.18) 100%)",
        }}
      />

      <div className="relative mx-auto w-full max-w-7xl px-6 py-32 lg:px-8 lg:py-40">
        <div className="grid items-center gap-16 lg:grid-cols-[1fr_420px]">

          {/* Left — Copy */}
          <div>
            <h1
              className="text-5xl font-bold leading-tight tracking-tight lg:text-6xl xl:text-7xl"
              style={{ color: "#1E293B" }}
            >
              Need help with your<br />
              <span style={{ color: "#4F7CFF" }}>car loan?</span>
            </h1>
            <p
              className="mt-6 text-lg leading-8 max-w-lg"
              style={{ color: "#475569" }}
            >
              We help vehicle owners in the Philippines understand their options
              when payments become difficult.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link
                to="/intake"
                className="inline-block whitespace-nowrap rounded-lg px-8 py-3.5 text-base font-semibold text-white transition cursor-pointer"
                style={gradientStyle}
                onMouseEnter={(e) =>
                  Object.assign((e.target as HTMLElement).style, gradientHover)
                }
                onMouseLeave={(e) =>
                  Object.assign((e.target as HTMLElement).style, gradientStyle)
                }
              >
                Get Your Options
              </Link>

              <a
                href="https://m.me/jglennverano?text=Hi%20I%20want%20to%20ask%20about%20my%20car%20loan%20options"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-lg px-7 py-3.5 text-base font-semibold text-white transition cursor-pointer"
                style={{ backgroundColor: "#0084FF" }}
                onMouseEnter={(e) =>
                  ((e.target as HTMLElement).style.backgroundColor = "#006FD6")
                }
                onMouseLeave={(e) =>
                  ((e.target as HTMLElement).style.backgroundColor = "#0084FF")
                }
              >
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-messenger-line text-base" />
                </span>
                Chat on Messenger
              </a>
            </div>

            <p className="mt-3 text-xs" style={{ color: "#94A3B8" }}>
              Usually replies within a few minutes
            </p>

            {/* Trust pills */}
            <div className="mt-8 flex flex-wrap gap-3">
              {["Legal & Compliant", "PH-Based Team", "Confidential"].map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-medium"
                  style={{ backgroundColor: "#EBF0FF", color: "#4F7CFF" }}
                >
                  <i className="ri-checkbox-circle-line text-xs" />
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Right — CTA Card */}
          <div
            className="rounded-2xl p-8 flex flex-col"
            style={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #E2E8F0",
              boxShadow: "0 8px 32px rgba(79,124,255,0.08)",
            }}
          >
            {/* Card header icon */}
            <div
              className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl"
              style={{ backgroundColor: "#EBF0FF" }}
            >
              <i className="ri-file-list-3-line text-2xl" style={{ color: "#4F7CFF" }} />
            </div>

            <h2 className="text-xl font-bold leading-snug" style={{ color: "#1E293B" }}>
              See Your Options<br />in Minutes
            </h2>
            <p className="mt-2 text-sm leading-6" style={{ color: "#475569" }}>
              Fill out a quick form and our PH-based team will walk you through your car loan options — no pressure, no obligations.
            </p>

            {/* Step list */}
            <ul className="mt-6 space-y-3">
              {[
                "Share basic vehicle &amp; loan info",
                "We review your situation",
                "You get clear, honest options",
              ].map((step, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span
                    className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white mt-0.5"
                    style={{ backgroundColor: "#4F7CFF" }}
                  >
                    {i + 1}
                  </span>
                  <span
                    className="text-sm"
                    style={{ color: "#475569" }}
                    dangerouslySetInnerHTML={{ __html: step }}
                  />
                </li>
              ))}
            </ul>

            {/* Primary CTA */}
            <Link
              to="/intake"
              className="mt-8 block w-full whitespace-nowrap rounded-lg py-3.5 text-center text-sm font-semibold text-white transition cursor-pointer"
              style={gradientStyle}
              onMouseEnter={(e) =>
                Object.assign((e.target as HTMLElement).style, gradientHover)
              }
              onMouseLeave={(e) =>
                Object.assign((e.target as HTMLElement).style, gradientStyle)
              }
            >
              Get Free Review
            </Link>

            <p className="mt-2 text-center text-xs" style={{ color: "#94A3B8" }}>
              Takes less than 60 seconds
            </p>

            {/* Messenger fallback */}
            <div className="mt-5 border-t pt-5" style={{ borderColor: "#F1F5F9" }}>
              <p className="text-center text-xs" style={{ color: "#94A3B8" }}>
                Prefer to chat instead?{" "}
                <a
                  href="https://m.me/jglennverano?text=Hi%20I%20want%20to%20ask%20about%20my%20car%20loan%20options"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium transition hover:underline"
                  style={{ color: "#0084FF" }}
                >
                  Message us on Messenger
                </a>
              </p>
            </div>

            {/* Trust note */}
            <p className="mt-3 text-center text-xs" style={{ color: "#94A3B8" }}>
              No pressure. Confidential. PH-based team.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}